// extracted by mini-css-extract-plugin
export default {"block":"uzgIKzvz0gMIpGilZhZw","separationLine":"q1erOgwGlrLqycXvTaNA"};